module.exports = __webpack_public_path__ + "img/folder.b7e1ead3.png";